export const sidebarNavigation = [
  { name: 'Inicio', href: '/welcome', icon: 'HomeIcon' },
  { name: 'Usuarios', href: '/users', icon: 'UserIcon', role: 'admin' },
]

export const sidebarNavigationFooter = [
  { name: 'Configuración', href: '/configuration/profile', icon: 'Cog6ToothIcon' },
]